import React__default from 'react';
import { S as SheetContextProvider } from '../Sheet/SheetContext-DthRk6uR.js';

const StormContextProvider = ({
  children
}) => /*#__PURE__*/React__default.createElement(SheetContextProvider, null, children);

export { StormContextProvider as S };
//# sourceMappingURL=StormContextProvider-BTxpbm54.js.map
